import Reader from './product/reader';
import Sender from './product/sender';
import Loader from '../modal/form/loader';

class CallAdd {
    /** @type {{wrap: string}} */
    selectors;

    constructor() {
        this.selectors = {
            wrap: '[data-cart-add]',
        };

        this.init();
    }

    /** @returns {CallAdd} */
    static run() {
        return new CallAdd();
    }

    /** @param {MouseEvent} e */
    btnClick = (e) => {
        /** @type {HTMLButtonElement|null} */
        const target = e.target.closest(this.selectors.wrap);

        if (target) {
            e.preventDefault();

            const Product = Reader.run({elem: target});
            const productData = Product.getData();

            if (Product.hasOptions) {
                Loader.run({
                    loadLink: `index.php?route=product/options&product_id=${Product.productId}`,
                    formData: {product_id: Product.productId},
                    initType: 'options',
                });
            } else {
                Sender.save(productData);
            }
        }
    };

    /** @return void */
    eventListeners() {
        document.addEventListener('click', this.btnClick);
    }

    /** @return void */
    init() {
        this.eventListeners();
    }
}

export default CallAdd;
